<template>
  <v-menu
    v-model="showMenu"
    auto
    min-width="400"
    :close-on-content-click="false"
  >
    <template #activator="{ on, attrs }">
      <slot :attrs="attrs" :on="on" />
    </template>
    <v-card>
      <v-card-text>
        <v-card-subtitle class="pa-0 pb-1 d-flex align-center justify-space-between">
          <span>Phone number</span>
          <v-btn
            text
            icon
            small
            @click="showMenu = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-subtitle>
        <div class="d-flex align-center">
          <v-autocomplete
            v-model="countryCode"
            outlined
            style="max-width: 90px"
            class="mr-1"
            item-text="name"
            item-value="iso"
            :items="countriesList"
            hide-details
            dense
          >
            <template #item="{ item }">
              <div class="d-flex align-center">
                <v-img
                  height="22"
                  width="36"
                  :src="item.flagUrl"
                  class="mr-1"
                />
                <span>{{ item.iso }}</span>
              </div>
            </template>
            <template #selection="{ item }">
              <v-img
                height="16"
                width="27"
                :src="item.flagUrl"
                class="mr-1"
              />
            </template>
          </v-autocomplete>
          <v-text-field
            v-model="phone"
            v-facade="phoneMask"
            top
            autofocus
            dense
            outlined
            hide-details
          />
          <v-text-field
            v-if="showExtension"
            v-model="extension"
            dense
            label="Extension"
            style="max-width: 105px"
            class="ml-2"
            outlined
            hide-details
          />
        </div>
        <div class="d-flex align-center mt-2 gap-2">
          <v-spacer />
          <v-btn height="30" outlined @click="showMenu = false">Cancel</v-btn>
          <v-btn height="30" color="primary" @click="savePhone">
            Save
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script lang="ts">
import mixins from 'vue-typed-mixins';

import { getCountryMask } from '@/bundles/Common/helpers/getCountries';
import { CountriesMasksMixin } from '@/bundles/Common/mixins/CountriesMasksMixin';
import { getAccountCountry } from '@/bundles/Companies/helpers/companyDefaultData';

interface ICommonPhonePicker {
  showMenu: boolean;
  phone: string;
  extension: string;
  countryCode: string;
  phoneMask: string;
}

export default mixins(CountriesMasksMixin).extend({
  name: 'CommonPhonePicker',

  props: {
    phoneCountryCode: {
      type: String,
      default: ''
    },
    phoneNumber: {
      type: String,
      default: ''
    },
    phoneExtension: {
      type: String,
      default: ''
    },
    showExtension: Boolean
  },

  data: (): ICommonPhonePicker => ({
    showMenu: false,
    phone: '',
    extension: '',
    countryCode: getAccountCountry(),
    phoneMask: getCountryMask([], getAccountCountry())
  }),

  watch: {
    showMenu () {
      this.phone = this.phoneNumber;
      this.extension = this.phoneExtension;
      this.countryCode = this.phoneCountryCode || getAccountCountry();
    },
    countryCode (value) {
      if (!value) {
        this.countryCode = getAccountCountry();
      }

      this.setMaskForCountry();
    }
  },

  methods: {
    savePhone () {
      this.$emit('save:number', this.phone);
      this.$emit('save:countryCode', this.countryCode);

      if (this.showExtension) {
        this.$emit('save:extension', this.extension);
        this.extension = '';
      }

      this.showMenu = false;
      this.phone = '';
    },
    setMaskForCountry () {
      this.phoneMask = getCountryMask(this.countriesList, this.countryCode);
    },
  }
});
</script>
